// Тема интерфейса (ux/12 §6): «Как в Telegram» по colorScheme и themeChanged, «Светлая», «Тёмная».
// Обвязка Telegram (шапка, фон, нижняя полоса 7.10+) всегда тёмная, в цвет сплэша: у игры своя палитра,
// светлая тема Telegram её не перекрашивает (решение координатора 01.11.2026).
import { storage } from '../state/storage.js';
import { versionAtLeast, type TgWebApp } from './webapp.js';

/** Цвет обвязки — тот же, что у сплэша (public/splash.js) и у заглушки Telegram в BotFather (фон LOADING-ICON). */
export const CHROME_COLOR = '#1b1f2e';

export type ThemeChoice = 'telegram' | 'light' | 'dark';

export function resolveTheme(choice: ThemeChoice, scheme: 'light' | 'dark' | undefined): 'light' | 'dark' {
  if (choice === 'light' || choice === 'dark') return choice;
  return scheme ?? (matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark');
}

export function applyTheme(wa: TgWebApp | null, root: HTMLElement = document.documentElement): 'light' | 'dark' {
  const t = resolveTheme((storage.get('theme') as ThemeChoice) ?? 'telegram', wa?.colorScheme);
  root.dataset.theme = t;
  const destructive = wa?.themeParams?.['destructive_text_color'];
  if (destructive) root.style.setProperty('--destructive', destructive);
  try {
    wa?.setHeaderColor?.(CHROME_COLOR);
    wa?.setBackgroundColor?.(CHROME_COLOR);
    if (wa && versionAtLeast(wa, '7.10')) wa.setBottomBarColor?.(CHROME_COLOR);
  } catch { /* старые клиенты — пропуск */ }
  return t;
}
